/**
 * @Description 功能都和V2Table一样，就样式不同
 */
import V2Table from '@/common/components/Data/V2Table';
import styles from './index.module.less';
import cs from 'classnames';

const TableOfBlue = ({ className = '', tableRef = null, ...props }) => {
  return (
    <V2Table
      className={cs(styles.table, className,
        props.isSmallSize ? styles.isSmallSizeGroup : '',
      )}
      ref={tableRef}
      {...props}
    />
  );
};
export default TableOfBlue;
